import "./Home.module.css";
import SiteNavigation from "@/reusable_sections/Header";
import FoundationsForGrowth from "./sections/FoundationsForGrowth";
import OurServices from "./sections/OurServices";
import EquipmentFieldCapabilities from "./sections/EquipmentFieldCapabilities";
import ProjectExperience from "./sections/ProjectExperience";
import ServiceAreaAvailability from "./sections/ServiceAreaAvailability";
import WhyChooseQstGeotechnical from "./sections/WhyChooseQstGeotechnical";
import WhoWeWorkWith from "./sections/WhoWeWorkWith";
import RequestAProposal from "./sections/RequestAProposal";
import ProjectBase from "@/reusable_sections/Footer";
import Sectors from "./sections/Sectors";
import BusinessPartnership from "./sections/BusinessPartnership";
export default function HomePage() {
  return <div>
      <SiteNavigation />
      <FoundationsForGrowth />
      <OurServices />
      <Sectors />
      <EquipmentFieldCapabilities />
      <ProjectExperience />
      <ServiceAreaAvailability />
      <WhyChooseQstGeotechnical />
      <BusinessPartnership />
      <WhoWeWorkWith />
      <RequestAProposal />
      <ProjectBase />
    </div>;
}